import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  GetPackage,
  getupdatehealthcondition,
  updatehealthcondition,
  UpdatePackage,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
class editpackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      radioVariant: "1",
      healthconditionname: "",
      healthconditionnameError: null,
      _notificationSystem: null,
      cardHidden: true,
      errormessages: [],
      package_code: "",
      tat: "",
      package_codeError: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Package</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    var pc_id = JSON.parse(localStorage.getItem("package_id"));
    // console.log(token);
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    // console.log(obj);
    GetPackage(pc_id, obj).then((response) => {
      var data = response.data;
      this.setState({
        packagename: data.package_name,
        packageprice: data.price,
        package_code: data.package_code,
        tat: data.tat,
      });
    });
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handlesubmit = (e) => {
    this.setState({ errormessages: [] });
    let error = false;
    // console.log(this.state.medicationcategoryname.length);

    if (this.state.packagename.length == 0) {
      error = true;
      this.setState({
        packagenameError: (
          <small className="text-danger">PackageName is required.</small>
        ),
      });
    } else {
      this.setState({ packagenameError: null });
    }
    if (this.state.package_code.length == 0) {
      error = true;
      this.setState({
        package_codeError: (
          <small className="text-danger">Package Code is required.</small>
        ),
      });
    } else {
      this.setState({ package_codeError: null });
    }
    if (this.state.packageprice.length == 0) {
      error = true;
      this.setState({
        packagepriceError: (
          <small className="text-danger">PackagePrice is required.</small>
        ),
      });
    } else {
      this.setState({ packagepriceError: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      // console.log(token.token);
      var package_id = JSON.parse(localStorage.getItem("package_id"));
      console.log("package_id", package_id);
      const obj = token.token;
      UpdatePackage(
        this.state.packagename,
        this.state.packageprice,
        this.state.package_code,
        this.state.tat,
        package_id,
        obj
      )
        .then((res) => {
          if (res.data.success === false) {
            const message = res.data.data;

            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.setState({
                healthconditionnameError: (
                  <small className="text-danger">
                    {message.healthconditionname}
                  </small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            setTimeout(() => {
              this.props.history.push("/admin/packagelist");
            }, 1500);
          }

          // this.props.history.push('/admin/medication-category');
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  };
  handleChange = (event) => {
    const target = event.target;
    this.setState({
      [target.name]: target.value,
    });
  };
  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel> Package Name</ControlLabel>
                      <FormControl
                        name="packagename"
                        value={this.state.packagename || ""}
                        onChange={(event) => {
                          this.setState({ packagename: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                packagenameError: (
                                  <small className="text-danger">
                                    PackageName is required.
                                  </small>
                                ),
                              })
                            : this.setState({ packagenameError: null });
                        }}
                        placeholder="Enter Package Name"
                        type="text"
                      />
                      {this.state.packagenameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel> Package Code</ControlLabel>
                      <FormControl
                        name="package_code"
                        value={this.state.package_code || ""}
                        onChange={(event) => {
                          this.setState({ package_code: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                package_codeError: (
                                  <small className="text-danger">
                                    Package Code is required.
                                  </small>
                                ),
                              })
                            : this.setState({ package_codeError: null });
                        }}
                        placeholder="Enter Package code"
                        min="0"
                        type="number"
                      />
                      {this.state.package_codeError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel> Package Price</ControlLabel>
                      <FormControl
                        name="packageprice"
                        value={this.state.packageprice || ""}
                        onChange={(event) => {
                          this.setState({ packageprice: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                packagepriceError: (
                                  <small className="text-danger">
                                    PackagePrice is required.
                                  </small>
                                ),
                              })
                            : this.setState({ packagepriceError: null });
                        }}
                        placeholder="Enter Package Price"
                        min="0"
                        type="number"
                      />
                      {this.state.packagepriceError}
                    </FormGroup>

                    <Button onClick={this.handlesubmit} class="btn-color" fill>
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default editpackage;
